@if (hasApps()) {
  <div class="switcher-wrap">
    <button
      type="button"
      class="switcher-trigger"
      cdkOverlayOrigin
      #switcherTrigger="cdkOverlayOrigin"
      (click)="toggle()"
      [attr.aria-expanded]="open()"
      aria-haspopup="menu"
      aria-label="App switcher"
      data-testid="app-switcher-trigger"
    >
      <app-icon name="grid" [size]="20" aria-hidden="true"></app-icon>
    </button>

    <ng-template
      cdkConnectedOverlay
      [cdkConnectedOverlayOrigin]="switcherTrigger"
      [cdkConnectedOverlayOpen]="open()"
      [cdkConnectedOverlayPositions]="panelPositions"
      [cdkConnectedOverlayHasBackdrop]="true"
      cdkConnectedOverlayBackdropClass="cdk-overlay-transparent-backdrop"
      (backdropClick)="close()"
      (detach)="close()"
    >
      <div class="switcher-panel" role="menu" data-testid="app-switcher-panel">
        <div class="switcher-header">Switch to</div>
        <div class="switcher-grid">
          @for (app of apps(); track app.id) {
            <a
              class="switcher-app"
              [href]="app.url"
              role="menuitem"
              (click)="navigate(app, $event)"
              (contextmenu)="openContextMenu(app, $event)"
            >
              <div class="switcher-app-icon">
                <img [src]="app.logo" [alt]="app.label" class="switcher-app-logo" />
              </div>
              <span class="switcher-app-label">{{ app.label }}</span>
            </a>
          }
        </div>
      </div>
    </ng-template>

    <!-- Right-click menu for a single tile, anchored to the cursor -->
    @if (contextMenu(); as ctx) {
      <ng-template
        cdkConnectedOverlay
        [cdkConnectedOverlayOrigin]="ctx.origin"
        [cdkConnectedOverlayOpen]="true"
        [cdkConnectedOverlayPositions]="contextMenuPositions"
        [cdkConnectedOverlayHasBackdrop]="true"
        cdkConnectedOverlayBackdropClass="cdk-overlay-transparent-backdrop"
        (backdropClick)="closeContextMenu()"
        (detach)="closeContextMenu()"
      >
        <div class="switcher-context-menu" role="menu" data-testid="app-switcher-context-menu">
          <button type="button" role="menuitem" class="switcher-context-item" (click)="openInNewTab(ctx.app)">
            Open in new tab
          </button>
        </div>
      </ng-template>
    }
  </div>
}
